import api from 'src/app/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { buildEncodedQueryString } from 'src/common';
import { Afsl, ClientPortalSetting, FetchAfslIdsResponse, FetchClientPortalSettingPayload } from './types';

export enum ClientPortalSettingsTypes {
  FetchClientPortalSetting = '@@templates/clientPortal/FetchSetting',
  SaveClientPortalSetting = '@@templates/clientPortal/SaveSetting',
  FetchAfsls = '@@templates/clientPortal/FetchAfslIds',
}

export enum ClientPortalSettingsEndpoints {
  FetchClientPortalSetting = '/bff/GetClientPortalReportingSettingByAfslId',
  SaveClientPortalSetting = '/bff/SetClientPortalReportingSettingByAfslId',
  FetchAfsls = '/bff/GetAfslsPracticesAdvisersForUser',
}

export const fetchClientPortalSetting = createAsyncThunk(
  ClientPortalSettingsTypes.FetchClientPortalSetting,
  async ({ afslId }: FetchClientPortalSettingPayload) => {
    const queryString = buildEncodedQueryString({
      afslId,
    });
    const response = await api.get<ClientPortalSetting>(`${ClientPortalSettingsEndpoints.FetchClientPortalSetting}${queryString}`);
    return response.data;
  }
);

export const saveClientPortalSetting = createAsyncThunk(
  ClientPortalSettingsTypes.SaveClientPortalSetting,
  async (payload: ClientPortalSetting, thunkApi) => {
    await api.post<ClientPortalSetting>(`${ClientPortalSettingsEndpoints.SaveClientPortalSetting}`, payload);
    await thunkApi.dispatch(fetchClientPortalSetting({ afslId: payload.afslId }));
    return { message: 'Client portal settings are updated ...' };
  }
);

export const fetchAfsls = createAsyncThunk<Afsl[]>(ClientPortalSettingsTypes.FetchAfsls, async () => {
  const response = await api.get<FetchAfslIdsResponse>(ClientPortalSettingsEndpoints.FetchAfsls);
  return response.data.afsls.map((a) => ({ id: a.afslId, name: a.afslName }));
});
